<template lang="pug">
    .center-x-y.take-max-height
        section.has-text-centered
            h1.title(v-if="code") Error {{ code }}
            h3.subtitle(v-if="message") {{ message }}
</template>

<script>

export default {
    name: 'Error',
    props: {
        code: {
            type: Number,
            required: false,
        },
        message: {
            type: String,
            required: false,
        },
    }
}
</script>

<style lang="sass" scoped>

.center-x-y.take-max-height
    min-height: 100%
    display: flex
    align-items: center
    justify-content: center

    section.has-text-centered
        color: #aaacb5
        text-align: center

        .title
            font-size: 6em
            font-weight: 100
            margin-bottom: 10px

        .subtitle
            font-size: 2em
            font-weight: 300
            margin-top: 10px
            margin-bottom: 80px
            // text-transform: uppercase
</style>

